// src/pages/legal/CancellationPolicyPage.tsx
import React from 'react';
import LegalDocumentPage from './LegalDocumentPage';

const CancellationPolicyPage: React.FC = () => (
  <LegalDocumentPage slug="cancellation-policy" fallbackTitle="Cancellation & No-Show Policy" />
);

export default CancellationPolicyPage;
